/**
 * @generated SignedSource<<a10885c27ae7d8d37452283832da2942>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetOverviewSize = "TWO_X_FOUR" | "TWO_X_ONE" | "TWO_X_THREE" | "TWO_X_TWO";
export type PreviewWidgetRoutineOverviewInput = {
  size?: WidgetOverviewSize | null;
  storecastId?: string | null;
  teamIds?: ReadonlyArray<string> | null;
};
export type WidgetChecklistOverviewPreviewQuery$variables = {
  input: PreviewWidgetRoutineOverviewInput;
  storecastId: string;
};
export type WidgetChecklistOverviewPreviewQuery$data = {
  readonly dashboard: {
    readonly previewWidgetRoutineOverview: {
      readonly " $fragmentSpreads": FragmentRefs<"WidgetRoutineOverviewDataComponent_widgetRoutineOverview">;
    };
  };
};
export type WidgetChecklistOverviewPreviewQuery = {
  response: WidgetChecklistOverviewPreviewQuery$data;
  variables: WidgetChecklistOverviewPreviewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storecastId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "storecastId"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WidgetChecklistOverviewPreviewQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v2/*: any*/),
          "concreteType": "Dashboard",
          "kind": "LinkedField",
          "name": "dashboard",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": (v3/*: any*/),
              "concreteType": "WidgetRoutineOverview",
              "kind": "LinkedField",
              "name": "previewWidgetRoutineOverview",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "WidgetRoutineOverviewDataComponent_widgetRoutineOverview"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WidgetChecklistOverviewPreviewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Dashboard",
        "kind": "LinkedField",
        "name": "dashboard",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "WidgetRoutineOverview",
            "kind": "LinkedField",
            "name": "previewWidgetRoutineOverview",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Routine",
                "kind": "LinkedField",
                "name": "routines",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Team",
                    "kind": "LinkedField",
                    "name": "ownerTeam",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoutineOccasion",
                    "kind": "LinkedField",
                    "name": "inProgressOccasion",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "expireAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "calculateNoTasks",
                            "value": true
                          },
                          {
                            "kind": "Literal",
                            "name": "calculateNotCompletedStarted",
                            "value": true
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "status",
                        "storageKey": "status(calculateNoTasks:true,calculateNotCompletedStarted:true)"
                      },
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "sequenceNumber",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "deadlineAt",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "cdd0e3d53dfae9f85ee8aec77222a478",
    "id": null,
    "metadata": {},
    "name": "WidgetChecklistOverviewPreviewQuery",
    "operationKind": "query",
    "text": "query WidgetChecklistOverviewPreviewQuery(\n  $storecastId: ID!\n  $input: PreviewWidgetRoutineOverviewInput!\n) {\n  dashboard(id: $storecastId) {\n    previewWidgetRoutineOverview(input: $input) {\n      ...WidgetRoutineOverviewDataComponent_widgetRoutineOverview\n      id\n    }\n    id\n  }\n}\n\nfragment RoutineOccasionStatusCircle_RoutineOccasion on RoutineOccasion {\n  status(calculateNoTasks: true, calculateNotCompletedStarted: true)\n  expireAt\n  deadlineAt\n  startAt\n}\n\nfragment WidgetRoutineOverviewDataComponent_widgetRoutineOverview on WidgetRoutineOverview {\n  id\n  title\n  routines {\n    id\n    ...WidgetRoutineOverviewListItem_routine\n    inProgressOccasion {\n      expireAt\n      startAt\n      status(calculateNoTasks: true, calculateNotCompletedStarted: true)\n      ...WidgetRoutineOverviewListItem_routineOccasion\n      id\n    }\n  }\n}\n\nfragment WidgetRoutineOverviewListItemExpireText_routineOccasion on RoutineOccasion {\n  startAt\n  expireAt\n  status(calculateNoTasks: true, calculateNotCompletedStarted: true)\n}\n\nfragment WidgetRoutineOverviewListItem_routine on Routine {\n  id\n  title\n  ownerTeam {\n    id\n    name\n  }\n}\n\nfragment WidgetRoutineOverviewListItem_routineOccasion on RoutineOccasion {\n  id\n  status(calculateNoTasks: true, calculateNotCompletedStarted: true)\n  sequenceNumber\n  ...WidgetRoutineOverviewListItemExpireText_routineOccasion\n  ...RoutineOccasionStatusCircle_RoutineOccasion\n}\n"
  }
};
})();

(node as any).hash = "39e528e33e9e388a736c7db467cff328";

export default node;
